import { useEffect, useState } from "react";
import { Box, Card, CardContent, Grid, Typography } from "../../../../components";
import { Divider, Skeleton } from "@mui/material";
import { MonitorFinanceiroService } from "../../../../services";
import { formatPrice, responseErros } from "../../../../utils";

const monitorFinanceiroService = new MonitorFinanceiroService();

const COR_FAIXA = "#d32f2f";
const defaultData = { faixas: [], tempoMedioRecebimento: 0, atrasoMedio: 0 };

function CardDias({ titulo, dias, icone, cor }) {
  return (
    <Box
      sx={{
        border: "1px solid #f0f0f0",
        borderRadius: 2,
        p: 1.5,
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        height: "100%",
      }}
    >
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: 2,
          backgroundColor: `${cor}18`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <i className={`ph-bold ${icone}`} style={{ color: cor, fontSize: 20 }} />
      </Box>
      <Box>
        <Typography
          variant="h5"
          sx={{ fontWeight: 800, color: "#1e293b", lineHeight: 1 }}
        >
          {dias}
          <Typography
            component="span"
            variant="caption"
            sx={{ color: "text.disabled", ml: 0.5 }}
          >
            dias
          </Typography>
        </Typography>
        <Typography variant="caption" sx={{ color: "text.secondary" }}>
          {titulo}
        </Typography>
      </Box>
    </Box>
  );
}

function MonitorFinPrazosInadimplencia({ filtrosBody }) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(defaultData);

  useEffect(() => {
    buscar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtrosBody]);

  async function buscar() {
    setLoading(true);
    const result =
      await monitorFinanceiroService.getDashboardPrazosInadimplencia(
        filtrosBody,
      );
    if (!result.isAxiosError) {
      setData(result.data || defaultData);
    } else {
      responseErros(result);
    }
    setLoading(false);
  }

  const faixas = data.faixas || [];
  const maxValor = Math.max(...faixas.map((f) => f.valor || 0), 0);

  return (
    <Card sx={{ borderRadius: 3, border: "1px solid #f0f0f0", height: "100%" }}>
      <CardContent sx={{ p: 2 }}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          mb={1}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
            Prazos e Inadimplência
          </Typography>
          <i
            className="ph-bold ph-clock-countdown"
            style={{ color: "#64748b", fontSize: 20 }}
          />
        </Box>
        <Divider sx={{ mb: 2 }} />
        {loading ? (
          <Box>
            {[1, 2, 3, 4, 5].map((i) => (
              <Skeleton
                key={i}
                variant="rectangular"
                height={26}
                sx={{ mb: 1.5, borderRadius: 1 }}
              />
            ))}
          </Box>
        ) : (
          <Grid container spacing={2}>
            <Grid item xs={12} md={7}>
              <Typography
                variant="caption"
                sx={{
                  fontWeight: 700,
                  color: "text.secondary",
                  textTransform: "uppercase",
                  letterSpacing: 0.5,
                }}
              >
                Faixa por Atraso
              </Typography>
              <Box sx={{ mt: 1.5 }}>
                {faixas.map((f) => {
                  const pct = maxValor > 0 ? (f.valor / maxValor) * 100 : 0;
                  return (
                    <Box key={f.faixa} sx={{ mb: 1.5 }}>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        mb={0.5}
                      >
                        <Typography variant="body2" sx={{ color: "#1e293b" }}>
                          {f.faixa}
                        </Typography>
                        <Box display="flex" alignItems="center" gap={1}>
                          <Typography
                            variant="body2"
                            sx={{ fontWeight: 700, color: "#1e293b" }}
                          >
                            {formatPrice(f.valor)}
                          </Typography>
                          <Typography
                            variant="caption"
                            sx={{
                              color: "text.disabled",
                              minWidth: 40,
                              textAlign: "right",
                            }}
                          >
                            {(f.percentual || 0).toFixed(1)}%
                          </Typography>
                        </Box>
                      </Box>
                      <Box
                        sx={{
                          width: "100%",
                          height: 8,
                          borderRadius: 4,
                          backgroundColor: "#f1f5f9",
                          overflow: "hidden",
                        }}
                      >
                        <Box
                          sx={{
                            width: `${pct}%`,
                            height: "100%",
                            borderRadius: 4,
                            backgroundColor: COR_FAIXA,
                            transition: "width 0.3s",
                          }}
                        />
                      </Box>
                    </Box>
                  );
                })}
              </Box>
            </Grid>
            <Grid item xs={12} md={5}>
              <Box
                display="flex"
                flexDirection="column"
                gap={1.5}
                sx={{ height: "100%", justifyContent: "center" }}
              >
                <CardDias
                  titulo="Tempo médio de recebimento"
                  dias={data.tempoMedioRecebimento || 0}
                  icone="ph-hourglass"
                  cor="#1976d2"
                />
                <CardDias
                  titulo="Atraso médio (vencidos)"
                  dias={data.atrasoMedio || 0}
                  icone="ph-calendar-x"
                  cor="#d32f2f"
                />
              </Box>
            </Grid>
          </Grid>
        )}
      </CardContent>
    </Card>
  );
}

export default MonitorFinPrazosInadimplencia;
